import React, {Component} from 'react'
import Screen from './_Screen'
import Button from './Button'
import styled from 'styled-components'

class Intro extends Screen
	render: ()->
		<Screen {@props...}>
			<Wrapper>
				<Title>{@props.title}</Title>
				<Subtitle>{@props.subtitle}</Subtitle>

				<Button label={@props.cta} action={@next.bind(@)} />
			</Wrapper>
		</Screen>
	
	onNextStep: ()->
		fbq?('trackCustom', 'InitiatedPurchase')



export Wrapper = styled.div"""
	text-align: center
"""

export Title = styled.h2"""
	font-size: 30px;
	font-weight: 400;
"""

export Subtitle = styled.div"""
	max-width: 460px;
	margin: 8px auto 30px;
	font-size: 18px;
	font-weight: 400;
	line-height: 1.5;
"""



export default Intro